/**
 * VendorFlagStatusService
 * Service for managing vendor flag statuses
 */
import { CrudService } from '../base/CrudService';
/**
 * Service for vendor flag status CRUD operations
 */
export class VendorFlagStatusService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? VendorFlagStatusService.DEFAULT_SERVICE_PATH,
            basePath: VendorFlagStatusService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
VendorFlagStatusService.DEFAULT_SERVICE_PATH = 'vendor-ratings';
VendorFlagStatusService.BASE_PATH = 'api/vendor-flag-statuses';
//# sourceMappingURL=VendorFlagStatusService.js.map